import defaults from './default.constants';

export const streamsConstants = {
  ...defaults.constants('streams'),
  ...defaults.rsf('paste_elements', 'streams'),
  PASTE_ELEMENTS_SAGA: 'STREAMS_PASTE_ELEMENTS_SAGA',
};
